import { ReceivablePublicAnnouncementBuild } from '../models/Entities';
import dateService from '../services/DateService';
import { adminApiAxios } from './CustomAxios';

class ReceivablePublicAnnouncementBuildApi {
    create = async (receivablePublicAnnouncementBuild: ReceivablePublicAnnouncementBuild): Promise<ReceivablePublicAnnouncementBuild> => {
        const response = await adminApiAxios.post<ReceivablePublicAnnouncementBuild>(
            `/receivable-public-announcement-builds`,
            receivablePublicAnnouncementBuild
        );
        this.loadDates(response.data);

        return response.data;
    };

    createDraft = async (receivablePublicAnnouncementBuild: ReceivablePublicAnnouncementBuild): Promise<ReceivablePublicAnnouncementBuild> => {
        const response = await adminApiAxios.post<ReceivablePublicAnnouncementBuild>(
            `/receivable-public-announcement-builds/draft`,
            receivablePublicAnnouncementBuild
        );
        this.loadDates(response.data);

        return response.data;
    };

    download = async (id: number): Promise<Blob> => {
        const response = await adminApiAxios.get<Blob>(`/receivable-public-announcement-builds/${id}/file`, {
            responseType: 'blob'
        });

        return response.data;
    };

    downloadDraft = async (receivablePublicAnnouncementBuild: ReceivablePublicAnnouncementBuild): Promise<Blob> => {
        const response = await adminApiAxios.post<Blob>(`/receivable-public-announcement-builds/draft/file`, receivablePublicAnnouncementBuild, {
            responseType: 'blob'
        });

        return response.data;
    };

    /**
     * Loads the dates of a receivablePublicAnnouncementBuild.
     * @param receivablePublicAnnouncementBuild - the receivable public announcement build
     */
    private loadDates(receivablePublicAnnouncementBuild: ReceivablePublicAnnouncementBuild) {
        receivablePublicAnnouncementBuild.audit!.created = dateService.transformDate(receivablePublicAnnouncementBuild.audit!.created)!;
        receivablePublicAnnouncementBuild.audit!.updated = dateService.transformDate(receivablePublicAnnouncementBuild.audit!.updated)!;
    }
}

const receivablePublicAnnouncementBuildApi: ReceivablePublicAnnouncementBuildApi = new ReceivablePublicAnnouncementBuildApi();
export default receivablePublicAnnouncementBuildApi;
